import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/base/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AtualizacoesAudit } from '../models/atualizacoes-audit.model';

@Injectable({
  providedIn: 'root',
})
export class AtualizacoesAuditService extends BaseService<AtualizacoesAudit> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/audit';
  }

  public getAtualizacoes(obj: Object = null): Observable<AtualizacoesAudit[]> {
    return this.http.post<AtualizacoesAudit[]>(
      this.baseUrl + '/atualizacoes',
      obj,
      { headers: this.headers }
    );
  }
}
